$(function () { 

	var ofiImages = $('.ofi');
	objectFitImages(ofiImages);

});